// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__19s1B","header":"MessagesList_header__2ZWdi","chat":"MessagesList_chat__2lkit"};